import React, { useEffect, useRef, useState } from "react";
import { DataGrid } from "@mui/x-data-grid"; // Material-UI DataGrid
import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";

const Suppliers = () => {
  const [saleReportData, setSaleReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const gridRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 130}px`;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    CommonAPImain("Performance_Vendor")
      .then((response) => {
        if (response?.Status == 200) {
          const saleData = response?.Data?.DT.map((item, index) => ({
            ...item,
            id: item.SrNo || index,
          }));
          setSaleReportData(saleData);
          setIsLoading(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "Vendor", headerName: "Supplier", width: 150 },
    { field: "GrossWt", headerName: "GWT", width: 120 },
    { field: "NetWt", headerName: "NWT", width: 120 },
    { field: "JobCount", headerName: "Job Count", width: 100 },
    { field: "Amount", headerName: "Amount", width: 120 },
  ];

  return (
    <div>
      <div
        ref={gridRef}
        style={{
          width: "100%",
          backgroundColor: "white",
        }}
      >
        <DataGrid
          rows={saleReportData}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          className="topReport_dataGrid_customer"
          loading={isLoading}
          localeText={{ noRowsLabel: "No Data" }}
          components={{
            Toolbar: () => null,
            LoadingOverlay: () => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default Suppliers;
